import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RequestService} from '../../../handlers/request/request.service';
import {globalEnv} from '../../connection/global/global.env';
import {bazzarvoiceApi} from '../../api/bazzarvoice/bazzarvoice.api';

@Injectable({
  providedIn: 'root',
})
export class BazzarvoiceService {
  constructor(private req: RequestService) {}

  reviews(params?): Observable<any> {
    const url = `${globalEnv.bzv}${bazzarvoiceApi.reviews}&Offset=${params.cursor}&Filter=ProductId:eq:${params.idProduct}`;
    return this.req.get(url, null, null, null, null, true);
  }

  summary(params): Observable<any> {
    const url = `${globalEnv.bzv}${bazzarvoiceApi.summary}&productid=${params}`;
    return this.req.get(url, null, null, null, null, true);
  }

  setReview(data): Observable<any> {
    const url = `${globalEnv.bzv}${bazzarvoiceApi.comments}`;
    return this.req.post(url, null, data, null, null, true);
  }
}
